import { Fragment } from "react/jsx-runtime";


export default function CCOtherAssessmentSummary(){

    return (<Fragment>
        <span className="pp-font-size-smallest">ABPN's ABCC pathway is not an option for this certification. <br />Please see the <a target="_BLANK" href="https://abpn.org/maintain-certification/taking-a-cc-exam/subspecialty-cc-exams/">ABPN Website</a> for more details.</span>
    </Fragment>)
}